import React from 'react';
import { FaSave, FaTimes } from 'react-icons/fa';
import { InlineSpinner } from '../../components/LoadingState';

// Override mode's Save/Cancel, as the Assessment Details card's footer. It is sticky to the bottom
// of the screen (bottom-0 inside <main>, the scroll container), so Save is always in reach while
// working down a long question list; at the end of the list it settles as the card's last row.
// card-footer-bleed (index.css) cancels the .card padding at every breakpoint so the bar runs
// edge to edge; bg-white follows the card into dark mode.
const OverrideSaveBar = ({ saving, changedCount = 0, disputeHint = false, onSave, onCancel }) => (
  <div className="override-save-bar card-footer-bleed sticky bottom-0 z-20 flex flex-wrap items-center gap-2 rounded-b-[14px] border-t border-gray-100 bg-white py-3 shadow-[0_-10px_20px_-14px_rgba(23,21,31,0.35)]">
    <button
      className='btn-primary disabled:opacity-50 disabled:cursor-not-allowed'
      onClick={onSave}
      disabled={saving}
    >
      {saving ? (
        <span className="flex items-center">
          <InlineSpinner className="mr-2" />
          Saving...
        </span>
      ) : (
        <><FaSave /> Save Changes</>
      )}
    </button>
    <button className='btn-secondary' onClick={onCancel} disabled={saving}>
      <FaTimes />
      Cancel
    </button>
    <span className="ml-2 flex items-center gap-2 text-sm text-gray-600" aria-live="polite">
      {disputeHint ? (
        <span className="italic text-gray-500">
          Make your changes, then click Save Changes to continue resolving this dispute.
        </span>
      ) : (
        <>
          <span
            className={`h-2 w-2 rounded-full ${changedCount > 0 ? 'bg-amber-500' : 'bg-gray-300'}`}
            aria-hidden="true"
          />
          <span>
            {changedCount > 0
              ? `${changedCount} question${changedCount === 1 ? '' : 's'} changed — not saved yet`
              : 'No changes yet'}
          </span>
        </>
      )}
    </span>
  </div>
);

export default OverrideSaveBar;
